import View from 'mixins/view';
import MatchCalendarDayView from 'ui/matchCalendar/match-calendar-day-view';
import MatchCalendarDayModel from 'models/MatchDayModel';
import { matchCalendarModel } from 'models/MatchCalendarModel';
import { repository } from 'repositories/matchCalendarRepository';
import Siema from 'siema';
import SiemaDynamicTimer from '@ui/siema-dynamic-timer';
import moment from 'moment/moment';

const elements = {
  container: '.match-calendarContainer',
  arrow: '.match-calendarArrow',
  time: '.match-calendarTime'
};

export default class extends View {
    constructor(model) {
        super(model);
        this.setRootEl($(elements.container));
        model.addEventListener('bulked', this.initSlider.bind(this));
        model.addEventListener('jumpToDay', this.updateCalendarPosition.bind(this));
    }
    buildDay(dayModel) {
        const matchCalendarDayView = new MatchCalendarDayView(dayModel);
        matchCalendarDayView.render();

        this.addChild(matchCalendarDayView);
        this.rootEl.append(matchCalendarDayView.getRootEl());
    }
    updateCalendarPosition({ direction, day }) {
      const activeDay = this.rootEl
        .find('.match-calendarElement__active');
      const activeIndex = this.rootEl
        .find('li')
        .index(activeDay);

      const getIndex = () => {
        if (activeIndex < 2) {
          return 0;
        }
        if (direction === 'back') {
          return activeIndex - 1;
        }
        if (direction === 'forward') {
          return activeIndex - this.showSlides + 2;
        }
        return 0;
      };

      this.slider.goTo(getIndex());
    }
    buildDynamicTime() {
      SiemaDynamicTimer.build(this.slider, elements.container, elements.time);
    }
    buildSlider() {
      const index = this.rootEl
        .find('.match-calendarElement')
        .index($('.match-calendarElement__active'));

      const allElementsCount = this.rootEl
        .find('.match-calendarElement')
        .length

      const showSlides = this.showSlides;

      const getActiveIndex = () => {
        // Protect to show empty lines in first load calendar
        return (index > (allElementsCount - showSlides))
          ? (allElementsCount - showSlides)
          : index;
      }

      const activeItemIndex = getActiveIndex();

      const elementsCount = this.rootEl
        .find('.match-calendarElement')
        .length;

      const swipeToScroll = this.swipeToScroll;

      const rightArrow = this.rightArrow;
      const leftArrow = this.leftArrow;
      const model = this.model;

      const setLastIndex = (index) => {
          this.lastIndex = index;
      };

      const classPointer = this;

      this.slider = new Siema({
        selector: elements.container,
        perPage: showSlides,
        startIndex: activeItemIndex - Math.floor(showSlides / 2),
        onInit() {
          if (index > (allElementsCount - showSlides)) {
            rightArrow.addClass('fn-hidden');
          }
        },
        onChange() {

          classPointer.buildDynamicTime();

          if (this.currentSlide > swipeToScroll) {
            leftArrow.removeClass('fn-hidden');
          }

          if (this.currentSlide < (elementsCount - showSlides)) {
            rightArrow.removeClass('fn-hidden');
          } else {
            rightArrow.addClass('fn-hidden');
          }

          if (this.currentSlide < (swipeToScroll * 2)) {
            const startDay = moment(model.get('lastDay'))
              .subtract(model.get('downloadingRange'), 'days')
              .format('YYYY-MM-DD');

            setLastIndex(this.currentSlide);

            repository.load({
                start: startDay,
                end: model.get('lastDay'),
              }).then(data => {
                model.addDays(data.calendar);
              });
          }

          this.previousSlide = this.currentSlide;
        }
      });
    }
    initSlider() {
      this.swipeToScroll = 4;
      const getShowSlides = () => {
        if ($(window).width() < 520) {
          return 4;
        } else if ($(window).width() < 768) {
          return 10;
        } else if ($(window).width() < 1000) {
          return 6;
        } else {
          return 9;
        }
      };
      this.showSlides = getShowSlides();

      if (this.slider) {
        this.slider.destroy();
      }

      this.rootEl.empty();

      const days = this.model.get('days');

      for (let i = 0; i < days.length; i++) {
        this.buildDay(days[i]);
      }

      this.buildSlider();
      this.buildDynamicTime();
    }
    initSliderArrows() {
      const elementsCount = this.rootEl
        .find('.match-calendarElement')
        .length;

      this.leftArrow.click(() => {
        if (this.slider.currentSlide <= this.swipeToScroll) {
          this.leftArrow.addClass('fn-hidden');
        }
        this.slider.prev(this.swipeToScroll);
      });

      this.rightArrow.click(() => {
        this.slider.next(this.swipeToScroll);
      });
    }
    render() {

        $(window).resize(this.initSlider.bind(this));

        this.leftArrow = $(`${elements.arrow}__left`);
        this.rightArrow = $(`${elements.arrow}__right`);

        this.initSlider();
        this.initSliderArrows();
    }
};



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/matchCalendar/match-calendar-view.js